import loadMoreVehicles from "../modules/Utils/loadMoreVehicles";

document.addEventListener('DOMContentLoaded', function () {
    loadMoreVehicles();
})